import { render, staticRenderFns } from "./brand-filter.vue?vue&type=template&id=5b915118&scoped=true"
import script from "./brand-filter.vue?vue&type=script&lang=js"
export * from "./brand-filter.vue?vue&type=script&lang=js"
import style0 from "./brand-filter.vue?vue&type=style&index=0&id=5b915118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b915118",
  null
  
)

export default component.exports